import { render } from "./Index.vue?vue&type=template&id=2d7b0dda&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=2d7b0dda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d7b0dda"

export default script